import React from 'react';
import classNames from 'classnames';

import { FONT_SIZES } from '../../../constants/font.constants';

export const HeadingLabel = ({
  bold = true, italic = false, className, children, size = FONT_SIZES['2XL'], ...rest
}) => (
  <h1 
    className={classNames(`text-white text-${size}`, className, {
      'font-bold': bold,
      'italic': italic,
    })}
    {...rest}
  >
    { children }
  </h1>
)

export default HeadingLabel;
